import DownloadIcon from "@mui/icons-material/Download";

export default DownloadIcon;
